// This is a collection of things that we likely shouldn't need to or want to do, and yet we are.

import allsettled from "promise.allsettled";

//Remove any <title> tags from container application before mounting
function removeLexisTitleElements() {
  const titles = [].slice.call(document.getElementsByTagName("title"));
  titles.forEach((title) => {
    if (!title.innerText || title.innerText === "Litigation Analytics")
      title.parentNode.removeChild(title);
  });
}

export function applyHacks() {
  allsettled.shim();
  setTimeout(() => {
    removeLexisTitleElements();
  }, 500);
}
